<template>
  <symForm :options="opt" :data.sync="formData" v-on:sended="setForm" :form.sync="userForm"
           :formProcess.sync="formProcess" v-if="userForm"/>
</template>

<script>
import symForm from '@/components/form/symForm';

export default {
  name: 'changePassword',
  components: {symForm},
  data() {
    return {
      session: session,
      userLoader: true,
      t: this.$root.t,
      users: null,
      regions: [],
      breadcrumb: [],
      userOpened: false,
      userForm: null,
      formProcess: 0,
      opt: {
        username: {data: [], label: 'username'},
      },
      formData: [],
      result: null
    }
  },
  mounted() {
    this.getUserForm();
  },
  notifications: {
    showFormError: { // You can have any name you want instead of 'showLoginError'
      title: 'Login Failed',
      message: 'Failed to authenticate',
      type: 'error' // You also can use 'VueNotifications.types.error' instead of 'error'
    }
  },
  methods: {
    async getUserForm(data) {


      this.userForm = null;
      this.formProcess = 0;
      this.$bus.$emit('globalLoader', 1);
      if (data) {

      } else {
        this.$http.get(api + 'api/change-password')
            .then(response => {
              this.userForm = response.body.result;
              this.formData = {username: ''};
              this.$bus.$emit('globalLoader', 0);
            }, response => {
              this.$bus.$emit('globalLoader', 0);
            })
      }

    },

    async setForm(data) {
      this.userForm = null;
      this.$http.post(api + 'api/change-password',
          data)
          .then(response => {

            this.userForm = response.body.result;
            this.formProcess = 200;

            swal('', this.t.processing.success, "success")
            this.$bus.$emit('globalLoader', 0);

          }, response => {
            this.userForm = response.body.result;
            this.formProcess = 400;
            swal(this.t.processing.error, this.t.processing.check, "error")
            this.$bus.$emit('globalLoader', 0);
          })

    },
    redirectHome() {
      window.location.href = '/';
    }
  }
}
</script>

<style scoped>

.bg-grey {
  background: #ebebeb;
}

.bg-darkgrey {
  background: #999999;
}

.clear {
  clear: both;
}

.hr {
  height: 1px;
  background-repeat: repeat-x;
  overflow: hidden;
  margin: 0;
}

.user-information h1 {
  padding: 12px 0 4px 12px;
  margin-bottom: 10px;
  color: #003366;
  border-bottom: 3px solid #003366;
  font-size: 15px;
  line-height: 20px;
}

.sheet-l {
  width: 25%;
  height: 24px;
  line-height: 24px;
  color: #666;
  text-align: right;
  padding-right: 20px;
  font-size: 11px;
}

.sheet-r {
  width: 75%;
  min-height: 24px;
  line-height: 24px;
  font-size: 12px;
  color: #000;
}

.sheet-l .main-header {
  color: #000;
  font-weight: bold;
}

.button-main {
  width: 180px;
  padding-right: 12px;
  min-height: 1px;
  position: relative;
}

.button-180.grey {
  width: 180px;
  height: 24px;
  cursor: pointer;
  background: #3c3c3c;
  padding-bottom: 2px;
  margin: 10px 0 10px 10px;
  line-height: 22px;
}

.button-180 {
  font-size: 14px;
  text-decoration: none;
  display: block;
  color: white;
  text-align: center;
}

.button-180:hover {
  color: #ef8107;
}

.input-text {
  padding: 0;
  margin: 0;
  width: 274px;
  margin-top: 3px;
  height: 16px;
  border: 1px solid #ccc;
  background: #fff;
  font-size: 11px;
  color: #666;
  padding-left: 2px;
}

.main-space p {
  font-size: 11px;
  padding-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/form/changePassword.vue